import { GetServerSideProps } from 'next';
import { CMSPageIds, CMSPageResponse, GearResponse, HomePageData, MenuResponse } from 'types';
import { getMenuData, getGearList, getCustomerActivities, getPageData } from 'api';
import { formatQueryFilters, getCanonicalUrlFromContext } from 'utils/formatters';
import { GearPage, LIST_LIMIT, GearPageProps } from 'containers/Gear';
import { getPageDescription } from 'utils/seoFormatters';

const Page = (props: GearPageProps) => <GearPage {...props} />;

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { query } = context;
  const force = !!query.force;

  const pageId: CMSPageIds = 'homepage';
  const appliedFilters = formatQueryFilters(query as Record<string, string | string[]>);

  const activitiesRequest = getCustomerActivities({}, force);
  const menuDataRequest: Promise<MenuResponse> = getMenuData(force);
  const gearsRequest: Promise<GearResponse> = getGearList({
    ...appliedFilters,
    limit: LIST_LIMIT * (query.page ? parseInt(query.page) : 1),
    page: 1,
  });
  const pageDataRequest: Promise<CMSPageResponse<HomePageData>> = getPageData(pageId, force);

  const [menuData, gears, activities, pageData] = await Promise.all([menuDataRequest, gearsRequest, activitiesRequest, pageDataRequest]);

  return {
    props: {
      menuData,
      initialGear: gears,
      activities,
      appliedFilters,
      pageData: pageData.content ? pageData.content : {},
      ogDataProps: {
        url: getCanonicalUrlFromContext(context),
        title: 'All gear | SENDY',
        description: getPageDescription('searchGear'),
      },
    },
  };
};

export default Page;
